import type { ServiceMethod, ServiceMethodData } from '../../utils/create-http-api-service';
import { defaultRequestService, ServiceOptions } from '../../utils/default-request-service';
import getStrapiServerUrl from './get-server-url';

// ---

async function strapiServiceAdapter<
  Data extends ServiceMethodData,
  TransformedData = null,
  ErrorData = null,
>(
  url: string,
  requestMethod: ServiceMethod<Data>,
  options?: ServiceOptions<Data, TransformedData, ErrorData>,
) {
  const fullUrl = `${getStrapiServerUrl()}${url}`;

  return defaultRequestService<Data, TransformedData, ErrorData>(fullUrl, requestMethod, options);
}

export { strapiServiceAdapter };
